module.exports = __webpack_public_path__ + "static/media/in.bdfaaf97.svg";